import { API_REQUEST } from 'omega-rtc/middlewares/api-middleware';
import type { FSA } from 'types/redux';

export const SEARCH_SMART_COMMS_JOURNEY = 'SEARCH_SMART_COMMS_JOURNEY';

interface SearchSmartCommsJourneyParams {
  userId: string;
  startDate: string;
  endDate: string;
  campaignId?: string;
}

export function searchSmartCommsJourney(params: SearchSmartCommsJourneyParams): FSA {
  const { userId, startDate, endDate, campaignId } = params;
  return {
    type: SEARCH_SMART_COMMS_JOURNEY,
    payload: {
      method: 'GET',
      url: '/ucd/comms-trace',
      params: {
        userID: userId,
        startDate: startDate.slice(0, 10),
        endDate: endDate.slice(0, 10),
        campaignID: campaignId,
        limit: 1000,
      },
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}
